'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _fabfitfunSharedUtils = require('@bit/fabfitfun.shared.utils.arg-types');

var _fabfitfunSharedUtils2 = _interopRequireDefault(_fabfitfunSharedUtils);

require('./BoxedTimer.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BoxedTimer = function (_React$PureComponent) {
  _inherits(BoxedTimer, _React$PureComponent);

  function BoxedTimer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BoxedTimer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BoxedTimer.__proto__ || Object.getPrototypeOf(BoxedTimer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      timer: {
        days: 0, hours: 0, minutes: 0, seconds: 0
      },
      timerIntervalId: -1
    }, _this.componentDidMount = function () {
      var interval = setInterval(_this.setTimer, 1000);
      _this.setState({ timerIntervalId: interval });
    }, _this.componentWillUnmount = function () {
      clearInterval(_this.state.timerIntervalId);
    }, _this.setTimer = function () {
      return _this.setState({
        timer: _this.getTimeUntilCampaignEnd(_this.props.sysdata.endTime)
      });
    }, _this.getTimeUntilCampaignEnd = function (rawUtcCampaignEndDate) {
      return _this.breakDownSeconds(_this.getSecondsUntilCampaignEnd(rawUtcCampaignEndDate));
    }, _this.getSecondsUntilCampaignEnd = function (rawUtcCampaignEndDate) {
      return Math.round(new Date(rawUtcCampaignEndDate).getTime() / 1000 - Date.now() / 1000);
    }, _this.insertZero = function (time) {
      var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

      if (time < threshold) {
        return '0' + time;
      }
      return time;
    }, _this.breakDownSeconds = function (secs) {
      var _this2 = _this,
          insertZero = _this2.insertZero;

      if (secs <= 0) {
        return {
          days: 0, hours: 0, minutes: 0, seconds: 0
        };
      }

      var days = Math.floor(secs / (3600 * 24));
      var hours = Math.floor(secs % (3600 * 24) / 3600);
      var minutes = Math.floor(secs % 3600 / 60);
      var seconds = Math.floor(secs % 3600 % 60);
      return {
        days: insertZero(days),
        hours: insertZero(hours),
        minutes: insertZero(minutes),
        seconds: insertZero(seconds)
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BoxedTimer, [{
    key: 'render',
    value: function render() {
      var scaleFactor = this.props.scaleFactor;
      var timer = this.state.timer;


      var timerItemStyles = (0, _classnames2.default)({
        'd-flex': true,
        'flex-fdc': true,
        'flex-aic': true,
        'pos-r': true,
        'fs-12': true,
        'fw-bold': true,
        'timer-item': true
      });

      return _react2.default.createElement(
        'section',
        {
          className: 'd-flex flex-jc w-100 box-timer-container',
          style: { transform: 'scale(' + scaleFactor + ')' }
        },
        _react2.default.createElement(
          'div',
          { className: timerItemStyles },
          _react2.default.createElement(
            'h5',
            null,
            timer.days
          ),
          _react2.default.createElement(
            'p',
            null,
            'Days'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: timerItemStyles },
          _react2.default.createElement(
            'h5',
            null,
            timer.hours
          ),
          _react2.default.createElement(
            'p',
            null,
            'Hrs'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: timerItemStyles },
          _react2.default.createElement(
            'h5',
            null,
            timer.minutes
          ),
          _react2.default.createElement(
            'p',
            null,
            'Min'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: timerItemStyles },
          _react2.default.createElement(
            'h5',
            null,
            timer.seconds
          ),
          _react2.default.createElement(
            'p',
            null,
            'Sec'
          )
        )
      );
    }
  }]);

  return BoxedTimer;
}(_react2.default.PureComponent);

BoxedTimer.propTypes = {
  sysdata: _propTypes2.default.shape({}),
  scaleFactor: _propTypes2.default.number
};

BoxedTimer.defaultProps = {
  sysdata: {
    endTime: '2020-01-04T21:19:00Z'
  },
  scaleFactor: 1
};

BoxedTimer.args = [{
  title: 'Scale Factor',
  key: 'scaleFactor',
  type: _fabfitfunSharedUtils2.default.NUMBER
}];

exports.default = BoxedTimer;

//# sourceMappingURL=BoxedTimer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bit/fabfitfun.shared.boxed-timer/dist/BoxedTimer.js
// module id = 713
// module chunks = 0